import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UsuarioEmpresaRoutingModule } from './usuario-empresa-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UsuarioEmpresaRoutingModule
  ]
})
export class UsuarioEmpresaModule { }
